import React from 'react';
import { List } from '@mantine/core';
import './list.styles.scss';

const StyledList = ({
  children,
  color = '#25F4F4',
  spacing = 'sm',
  size = 'sm',
  className,
  ...otherProps
}) => {
  const bulletIcon = (
    <span
      style={{
        color: color,
        marginRight: '1rem'
      }}
    >
      •
    </span>
  );

  return (
    <div className={`styled-list ${className}`}>
      <List spacing={spacing} size={size} icon={bulletIcon} className="fs-p" {...otherProps}>
        {children}
      </List>
    </div>
  );
};

export default StyledList;
